import { render, staticRenderFns } from "./routine.vue?vue&type=template&id=01cf5a2c&scoped=true&"
import script from "./routine.vue?vue&type=script&lang=js&"
export * from "./routine.vue?vue&type=script&lang=js&"
import style0 from "./routine.vue?vue&type=style&index=0&id=01cf5a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cf5a2c",
  null
  
)

export default component.exports